import React, { useState } from "react";
import Header from "./Header"; // Your existing header component
import "./locations/LocationDetails.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaRupeeSign,
} from "react-icons/fa";
import { useParams } from "react-router-dom";
// Individual location components

const GurajadaKalakshetram = () => {
  const images = [
    "bookings/images/gurajada.jpg",
    "bookings/images/gurajada1.jpg",
    "bookings/images/gurujada2.jpg",
  ];

  const pricingData = [
    {
      id: 1,
      purpose: "Government Schools (Cultural Activities)",
      rent: 10000,
      deposit: 5000,
      gst: 1800,
      total: 16800,
    },
    {
      id: 2,
      purpose: "Private Schools / Colleges",
      rent: 50000,
      deposit: 30000,
      gst: 9000,
      total: 89000,
    },
    {
      id: 3,
      purpose: "Cultural Programs (VUDA Jurisdiction)",
      rent: 10000,
      deposit: 20000,
      gst: 1800,
      total: 31800,
    },
    {
      id: 4,
      purpose: "Weddings / Receptions / Private Events",
      rent: 150000,
      deposit: 50000,
      gst: 27000,
      total: 227000,
    },
    {
      id: 5,
      purpose: "Religious Activities",
      rent: 50000,
      deposit: 30000,
      gst: 9000,
      total: 89000,
    },
  ];

  return (
    <div>
      <div className="location-page">
        {/* Hero Section */}
        <div className="hero">
          <Carousel showThumbs={false} autoPlay interval={3000} infiniteLoop>
            {images.map((url, idx) => (
              <div key={idx} className="carousel-image">
                <img src={url} alt={`Gurajada Image ${idx + 1}`} />
                <div className="overlay">
                  <h1>Gurajada Kalakshetram</h1>
                  <p>Premier Cultural Venue in Vizag</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        {/* Venue Details */}
        <div className="location-details">
          <h2>About the Venue</h2>
          <p className="line-height">
            <strong>Gurajada Kalakshetram</strong>, located at{" "}
            <strong>Siripuram Junction, Vizag</strong>, is a renowned cultural
            landmark, offering a platform for various events such as theatre
            performances, school celebrations, concerts, weddings, and private
            gatherings. Managed by <strong>VMRDA</strong>, this venue boasts
            modern amenities, including spacious seating, air-conditioned halls,
            and high-quality sound systems.
          </p>

          {/* Amenities Section */}
          <h3>Key Amenities</h3>
          <ul className="amenities-list">
            <li>✅ Fully Air-conditioned Auditorium</li>
            <li>✅ Spacious Seating Capacity</li>
            <li>✅ Advanced Sound & Lighting System</li>
            <li>✅ Large Parking Area</li>
            <li>✅ Dedicated Backstage & Green Rooms</li>
          </ul>

          {/* Pricing Section */}
          <h3>📌 Venue Pricing Details</h3>
          <div className="pricing-container">
            {pricingData.map((item) => (
              <div key={item.id} className="pricing-card">
                <h4>{item.purpose}</h4>
                <p>
                  <FaRupeeSign /> Rent per Day:{" "}
                  <strong>{item.rent.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Security Deposit:{" "}
                  <strong>{item.deposit.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> GST (18%):{" "}
                  <strong>{item.gst.toLocaleString()}</strong>
                </p>
                <p className="total">
                  <FaRupeeSign />{" "}
                  <strong>Total: {item.total.toLocaleString()}</strong>
                </p>
              </div>
            ))}
          </div>

          {/* Additional Charges */}
          <p className="note">
            <strong>Note:</strong> Electrical charges as consumed and sweeping
            charges of ₹5,000 + GST (18%) will be paid by the applicant to
            VMRDA.
          </p>

          {/* Contact Section */}
          <h3>📞 Contact Information</h3>
          <div className="contact-info">
            <p>
              <FaMapMarkerAlt /> Location: Siripuram Junction, Visakhapatnam
            </p>
            <p>
              <FaPhoneAlt /> Phone: +91 98765 43210
            </p>
            <p>
              <FaEnvelope /> Email: info@gurajadakalakshetram.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const MGMLawns = () => {
  const images = [
    "bookings/images/mgm.jpeg",
    "bookings/images/mgm2.jpg",
    "bookings/images/mgm.jpeg",
  ];

  const pricingData = [
    {
      id: 1,
      name: "MGM Lawn 1",
      purpose:
        "Birthday Functions & Other Official/ Corporate Meetings/ Get-together/Marriage/ Engagements/ Receptions.(General Meetings)",
      rent: 50000,
      deposit: 20000,
      gst: 9000,
      total: 79000,
    },
    {
      id: 2,
      name: "MGM Lawn 2",
      purpose:
        "Birthday Functions & Other Official/ Corporate Meetings/ Get-together/Marriage/ Engagements/ Receptions.(General Meetings)",
      rent: 25000,
      deposit: 10000,
      gst: 4500,
      total: 39500,
    },
    {
      id: 3,
      name: "MGM Lawn 3",
      purpose:
        "Birthday Functions & Other Official/ Corporate Meetings/ Get-together/Marriage/ Engagements/ Receptions.(General Meetings)",
      rent: 25000,
      deposit: 10000,
      gst: 4500,
      total: 39500,
    },
  ];

  return (
    <div>
      <div className="location-page">
        <div className="hero">
          <Carousel showThumbs={false} autoPlay interval={3000} infiniteLoop>
            {images.map((url, idx) => (
              <div key={idx} className="carousel-image">
                <img src={url} alt={`MGM Lawns Image ${idx + 1}`} />
                <div className="overlay">
                  <h1>MGM Lawns</h1>
                  <p>Premium Event Space in Vizag</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        <div className="location-details">
          <h2>About the Venue</h2>
          <p className="line-height">
            <strong>MGM Lawns</strong>, situated in{" "}
            <strong>Visakhapatnam</strong>, is an elegant venue ideal for a
            variety of events, including{" "}
            <strong>
              corporate gatherings, weddings, school functions, and private
              celebrations
            </strong>
            . It offers spacious open lawns, modern amenities, and an
            air-conditioned auditorium.
          </p>

          <h3>Key Amenities</h3>
          <ul className="amenities-list">
            <li>✅ Expansive Open Lawn</li>
            <li>✅ Fully Air-conditioned Auditorium</li>
            <li>✅ High-quality Sound & Lighting System</li>
            <li>✅ Ample Parking Space</li>
            <li>✅ Dedicated Green Rooms & Dressing Areas</li>
          </ul>

          <h3>📌 Venue Pricing Details</h3>
          <div className="pricing-container">
            {pricingData.map((item) => (
              <div key={item.id} className="pricing-section">
                <h2 className="lawn-title">{item.name}</h2>
                <div className="pricing-card">
                  <h4>{item.purpose}</h4>
                  <p>
                    <FaRupeeSign /> Rent per Day:{" "}
                    <strong>{item.rent.toLocaleString()}</strong>
                  </p>
                  <p>
                    <FaRupeeSign /> Security Deposit:{" "}
                    <strong>{item.deposit.toLocaleString()}</strong>
                  </p>
                  <p>
                    <FaRupeeSign /> GST (18%):{" "}
                    <strong>{item.gst.toLocaleString()}</strong>
                  </p>
                  <p className="total">
                    <FaRupeeSign />{" "}
                    <strong>Total: {item.total.toLocaleString()}</strong>
                  </p>
                </div>
              </div>
            ))}
          </div>

          <p className="note">
            <strong>Note:</strong> Electrical charges as consumed and sweeping
            charges of ₹2,000 + GST (18%) will be paid by the applicant to
            VMRDA.
          </p>

          <h3>📞 Contact Information</h3>
          <div className="contact-info">
            <p>
              <FaMapMarkerAlt /> Location: Visakhapatnam
            </p>
            <p>
              <FaPhoneAlt /> Phone: +91 98765 43210
            </p>
            <p>
              <FaEnvelope /> Email: info@mgmlawns.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const Chinnamusidivada = () => {
  const images = [
    "bookings/images/image2.jpeg",
    "bookings/images/chinnamusivada2.webp",
    "bookings/images/image1.jpeg",
  ];

  const pricingData = [
    {
      id: 1,
      purpose: "All activities/ Any meetings",
      rent: 200000,
      total: 200000,
    },
  ];

  return (
    <div>
      <div className="location-page">
        <div className="hero">
          <Carousel showThumbs={false} autoPlay interval={3000} infiniteLoop>
            {images.map((url, idx) => (
              <div key={idx} className="carousel-image">
                <img src={url} alt={`Chinnamusivada Image ${idx + 1}`} />
                <div className="overlay">
                  <h1>Chinnamusivada</h1>
                  <p>Venue for Diverse Cultural Activities</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        <div className="location-details">
          <h2>About the Venue</h2>
          <p className="line-height">
            <strong>Chinnamusivada</strong> is located at{" "}
            <strong>Near Chinnamusivada, Vizag</strong>, serving as a prime
            location for cultural events, community gatherings, educational
            activities, and more. The venue is equipped with modern facilities
            and ample space to accommodate various events.
          </p>

          <h3>Key Amenities</h3>
          <ul className="amenities-list">
            <li>✅ Large Indoor Hall</li>
            <li>✅ Good Acoustics</li>
            <li>✅ Easy Accessibility</li>
            <li>✅ Parking and Toilets Available</li>
          </ul>

          <h3>📌 Venue Pricing Details</h3>
          <div className="pricing-container">
            {pricingData.map((item) => (
              <div key={item.id} className="pricing-card">
                <h4>{item.purpose}</h4>
                <p>
                  <FaRupeeSign /> Rent per Day:{" "}
                  <strong>{item.rent.toLocaleString()}</strong>
                </p>

                <p className="total">
                  <FaRupeeSign />{" "}
                  <strong>Total: {item.total.toLocaleString()}</strong>
                </p>
              </div>
            ))}
          </div>

          <p className="note">
            <strong>Note:</strong> Additional charges for electricity and
            cleaning may apply.
          </p>

          <h3>📞 Contact Information</h3>
          <div className="contact-info">
            <p>
              <FaMapMarkerAlt /> Location: Near Chinnamusivada, Vizag
            </p>
            <p>
              <FaPhoneAlt /> Phone: +91 98765 43210
            </p>
            <p>
              <FaEnvelope /> Email: info@chinnamusivadavenue.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const ChildrensArena = () => {
  const images = [
    "bookings/images/image3.jpeg",
    "bookings/images/image9.jpeg",
    "bookings/images/image10.jpeg",
  ];

  const auditoriumPricing = [
    {
      id: 1,
      purpose: "Birthday / Corporate / Marriage Functions",
      rent: 30000,
      deposit: 30000,
      gst: 5400,
      total: 65400,
    },
    {
      id: 2,
      purpose: "Government Schools (Cultural Activities)",
      rent: 10000,
      deposit: 20000,
      gst: 1800,
      total: 31800,
    },
    {
      id: 3,
      purpose: "Private Schools (Cultural Activities)",
      rent: 30000,
      deposit: 30000,
      gst: 5400,
      total: 65400,
    },
  ];

  const theatrePricing = [
    {
      id: 4,
      purpose: "General Public (Theatre)",
      rent: 50000,
      deposit: 30000,
      gst: 9000,
      total: 89000,
    },
  ];

  return (
    <div>
      <div className="location-page">
        <div className="hero">
          <Carousel showThumbs={false} autoPlay interval={3000} infiniteLoop>
            {images.map((url, idx) => (
              <div key={idx} className="carousel-image">
                <img src={url} alt={`Children's Area Image ${idx + 1}`} />
                <div className="overlay">
                  <h1>Children's Arena</h1>
                  <p>Venue for Kids and Community Events</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        <div className="location-details">
          <h2>About the Venue</h2>
          <p className="line-height">
            <strong>Children's Area</strong>, located in{" "}
            <strong>Vuda Children's Arena, Vizag</strong>, is a venue primarily
            for children's events, educational activities, and community
            gatherings. With a spacious hall and all necessary amenities, this
            venue is perfect for various activities.
          </p>

          <h3>Key Amenities</h3>
          <ul className="amenities-list">
            <li>✅ Spacious Auditorium</li>
            <li>✅ Child-Friendly Facilities</li>
            <li>✅ Air Conditioning</li>
            <li>✅ Good Parking Facilities</li>
          </ul>

          <h3>📌 Venue Pricing Details</h3>

          {/* Auditorium Pricing Section */}
          <h4 style={{ color: "#5abf9d" }}>Auditorium in Ground Floor (A/c)</h4>
          <div className="pricing-container">
            {auditoriumPricing.map((item) => (
              <div key={item.id} className="pricing-card">
                <h4>{item.purpose}</h4>
                <p>
                  <FaRupeeSign /> Rent per Day:{" "}
                  <strong>{item.rent.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Security Deposit:{" "}
                  <strong>{item.deposit.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> GST (18%):{" "}
                  <strong>{item.gst.toLocaleString()}</strong>
                </p>
                <p className="total">
                  <FaRupeeSign />{" "}
                  <strong>Total: {item.total.toLocaleString()}</strong>
                </p>
              </div>
            ))}
          </div>

          {/* Theatre Pricing Section */}
          <h4 style={{ color: "#5abf9d", paddingTop: "25px" }}>
            {" "}
            Theatre in First Floor (A/c)
          </h4>
          <div className="pricing-container">
            {theatrePricing.map((item) => (
              <div key={item.id} className="pricing-card">
                <h4>{item.purpose}</h4>
                <p>
                  <FaRupeeSign /> Rent per Day:{" "}
                  <strong>{item.rent.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Security Deposit:{" "}
                  <strong>{item.deposit.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> GST (18%):{" "}
                  <strong>{item.gst.toLocaleString()}</strong>
                </p>
                <p className="total">
                  <FaRupeeSign />{" "}
                  <strong>Total: {item.total.toLocaleString()}</strong>
                </p>
              </div>
            ))}
          </div>

          <p className="note">
            <strong>Note:</strong> Additional charges for electricity and
            cleaning may apply.
          </p>

          <h3>📞 Contact Information</h3>
          <div className="contact-info">
            <p>
              <FaMapMarkerAlt /> Location: Vuda Children's Arena, Vizag
            </p>
            <p>
              <FaPhoneAlt /> Phone: +91 98765 43210
            </p>
            <p>
              <FaEnvelope /> Email: info@childrensarea.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const ThotlakondaPark = () => {
  const images = [
    "bookings/images/image3.jpeg",
    "bookings/images/image9.jpeg",
    "bookings/images/image10.jpeg",
  ];

  const auditoriumPricing = [
    {
      id: 1,
      purpose: "Birthday / Corporate / Marriage Functions",
      rent: 30000,
      deposit: 30000,
      gst: 5400,
      total: 65400,
    },
    {
      id: 2,
      purpose: "Government Schools (Cultural Activities)",
      rent: 10000,
      deposit: 20000,
      gst: 1800,
      total: 31800,
    },
    {
      id: 3,
      purpose: "Private Schools (Cultural Activities)",
      rent: 30000,
      deposit: 30000,
      gst: 5400,
      total: 65400,
    },
  ];

  const theatrePricing = [
    {
      id: 4,
      purpose: "General Public (Theatre)",
      rent: 50000,
      deposit: 30000,
      gst: 9000,
      total: 89000,
    },
  ];

  return (
    <div>
      <div className="location-page">
        <div className="hero">
          <Carousel showThumbs={false} autoPlay interval={3000} infiniteLoop>
            {images.map((url, idx) => (
              <div key={idx} className="carousel-image">
                <img src={url} alt={`Children's Area Image ${idx + 1}`} />
                <div className="overlay">
                  <h1>Children's Arena</h1>
                  <p>Venue for Kids and Community Events</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        <div className="location-details">
          <h2>About the Venue</h2>
          <p className="line-height">
            <strong>Children's Area</strong>, located in{" "}
            <strong>Vuda Children's Arena, Vizag</strong>, is a venue primarily
            for children's events, educational activities, and community
            gatherings. With a spacious hall and all necessary amenities, this
            venue is perfect for various activities.
          </p>

          <h3>Key Amenities</h3>
          <ul className="amenities-list">
            <li>✅ Spacious Auditorium</li>
            <li>✅ Child-Friendly Facilities</li>
            <li>✅ Air Conditioning</li>
            <li>✅ Good Parking Facilities</li>
          </ul>

          <h3>📌 Venue Pricing Details</h3>

          {/* Auditorium Pricing Section */}
          <h4 style={{ color: "#5abf9d" }}>Auditorium in Ground Floor (A/c)</h4>
          <div className="pricing-container">
            {auditoriumPricing.map((item) => (
              <div key={item.id} className="pricing-card">
                <h4>{item.purpose}</h4>
                <p>
                  <FaRupeeSign /> Rent per Day:{" "}
                  <strong>{item.rent.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Security Deposit:{" "}
                  <strong>{item.deposit.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> GST (18%):{" "}
                  <strong>{item.gst.toLocaleString()}</strong>
                </p>
                <p className="total">
                  <FaRupeeSign />{" "}
                  <strong>Total: {item.total.toLocaleString()}</strong>
                </p>
              </div>
            ))}
          </div>

          {/* Theatre Pricing Section */}
          <h4 style={{ color: "#5abf9d", paddingTop: "25px" }}>
            {" "}
            Theatre in First Floor (A/c)
          </h4>
          <div className="pricing-container">
            {theatrePricing.map((item) => (
              <div key={item.id} className="pricing-card">
                <h4>{item.purpose}</h4>
                <p>
                  <FaRupeeSign /> Rent per Day:{" "}
                  <strong>{item.rent.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> Security Deposit:{" "}
                  <strong>{item.deposit.toLocaleString()}</strong>
                </p>
                <p>
                  <FaRupeeSign /> GST (18%):{" "}
                  <strong>{item.gst.toLocaleString()}</strong>
                </p>
                <p className="total">
                  <FaRupeeSign />{" "}
                  <strong>Total: {item.total.toLocaleString()}</strong>
                </p>
              </div>
            ))}
          </div>

          <p className="note">
            <strong>Note:</strong> Additional charges for electricity and
            cleaning may apply.
          </p>

          <h3>📞 Contact Information</h3>
          <div className="contact-info">
            <p>
              <FaMapMarkerAlt /> Location: Vuda Children's Arena, Vizag
            </p>
            <p>
              <FaPhoneAlt /> Phone: +91 98765 43210
            </p>
            <p>
              <FaEnvelope /> Email: info@childrensarea.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const LocationDetails = () => {
  const id = useParams();
  console.log(id, "id");
  const [activeTab, setActiveTab] = useState(1); // Default tab is 1

  const handleTabClick = (id) => {
    setActiveTab(id);
  };

  // Determine which component to render based on the active tab
  let ActiveComponent;
  switch (activeTab) {
    case 1:
      ActiveComponent = GurajadaKalakshetram;
      break;
    case 2:
      ActiveComponent = MGMLawns;
      break;
    case 3:
      ActiveComponent = Chinnamusidivada;
      break;
    case 4:
      ActiveComponent = ChildrensArena;
      break;
    case 5:
      ActiveComponent = ThotlakondaPark;
      break;
    default:
      ActiveComponent = GurajadaKalakshetram;
  }

  return (
    <div>
      {/* Header Component */}
      <Header />

      {/* Main Content */}
      <div className="location-details-container">
        {/* Tabs */}

        <div className="location-content">
          <ActiveComponent />
        </div>
      </div>
    </div>
  );
};

export default LocationDetails;


